import ModeloBodegaDivisiones from 'Infotrack@Modelos/smartStock/bodegasDivisiones';
import ModeloItems from 'Infotrack@Modelos/smartStock/items';
import Bodega from 'Infotrack@Modelos/smartStock/bodegas';

class EntidadesDetalleCM {
    private modeloBodegaDivision: ModeloBodegaDivisiones;
    private modeloItem: ModeloItems;
    private modeloBodega: Bodega;

    constructor() {
        this.modeloBodegaDivision = new ModeloBodegaDivisiones();
        this.modeloItem = new ModeloItems();
        this.modeloBodega = new Bodega();
    }

    public async consultarEntidadesDetalle(
        bodegaDestinoId: number,
        tipoDocumentoId: number,
        EmpresaId: string,
        AgenciaId: string,
        UsuarioId: string
    ) {
        const respuestas = await Promise.all([
            this.modeloBodegaDivision.consultarDivisionesDocumentosDef({
                BodegaId: bodegaDestinoId,
                TipoDocumentoId: tipoDocumentoId,
            }),
            this.modeloBodega.consultarBodegasPersonasDoc({ AgenciaId, UsuarioId, EmpresaId }),
        ]);
        return {
            divisionesDestino: respuestas[0].data.Entidades,
            bodegasDestino: respuestas[1].data.Entidades,
        };
    }

    public async consultarItem(itemId: number,empresaId:string) {
        const respuestas = await Promise.all([
            this.modeloItem.consultarListaItemsCompuestosFiltro({EmpresaId:empresaId, Estado:1,ItemId:itemId}),
        ]);
        return {
            itemsConsulta: respuestas[0].data.Entidades,
        };
    }
}

export default EntidadesDetalleCM;
